import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import FloatingButtons from '../components/FloatingButtons/FloatingButtons';
import { newArrivals, featuredCollection, specialOne, highlights } from '../data/products';
import { preWeddingProducts, kidsBirthdayProducts } from '../data/categoryProducts';

const Search = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const query = searchParams.get('q') || '';
  const [results, setResults] = useState([]);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [query]);

  useEffect(() => {
    if (!query) {
      setResults([]);
      return;
    }

    // Combine all products
    const allProducts = [
      ...newArrivals,
      ...featuredCollection,
      ...specialOne,
      ...highlights.birthday,
      ...highlights.anniversary,
      ...highlights.babyShower,
      ...highlights.gifting,
      ...preWeddingProducts,
      ...kidsBirthdayProducts
    ];

    // Filter products based on search query
    const filtered = allProducts.filter((product) =>
      product.title.toLowerCase().includes(query.toLowerCase())
    );

    // Remove duplicates based on id
    const uniqueResults = filtered.filter(
      (product, index, self) => index === self.findIndex((p) => p.id === product.id)
    );

    setResults(uniqueResults);
  }, [query]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#8B1538] mb-4 sm:mb-6">
          Search Results
        </h1>
        {query && (
          <p className="text-gray-600 mb-8 sm:mb-12">
            {results.length} result{results.length !== 1 ? 's' : ''} found for "{query}"
          </p>
        )}

        {!query ? (
          <div className="text-center py-12 sm:py-20">
            <p className="text-gray-500 text-lg sm:text-xl">
              Enter a search term to find products
            </p>
          </div>
        ) : results.length === 0 ? (
          <div className="text-center py-12 sm:py-20">
            <p className="text-gray-500 text-lg sm:text-xl mb-4">
              No products found for "{query}"
            </p>
            <p className="text-gray-400 text-sm sm:text-base">
              Try searching with different keywords
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-6">
            {results.map((product) => (
              <div
                key={product.id}
                className="w-full cursor-pointer"
                onClick={() => navigate(`/product/${product.id}`)}
              >
                <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
                  <div className="relative aspect-square overflow-hidden bg-gray-100">
                    <img
                      src={product.image}
                      alt={product.title}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                    />
                    <div className="absolute top-2 left-2 text-xs font-semibold text-gray-600 opacity-50">
                      PartyNestt
                    </div>
                  </div>
                  <div className="p-3 sm:p-4">
                    <h3 className="text-xs sm:text-base font-medium text-gray-800 line-clamp-2 min-h-[2rem] sm:min-h-[2.5rem]">
                      {product.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Search;

